export const waitlistPageMessages = {
  // Page content
  title: 'Get ready for the Warm Fuzzies!',
  description:
    'Get early access to our personalized story creation platform and be the first to know about exciting new offers',

  // Form elements
  emailLabel: 'Email address',
  emailPlaceholder: 'Enter your email address',
  submitButton: 'Join Waitlist',
  submittingButton: 'Joining...',

  // Captcha
  captchaLabel: 'Security verification',
  captchaRequired: 'Please complete the security verification',

  // Consent
  consentText:
    'I consent to the processing of my personal data according to the privacy policy',
  consentRequired: 'You must consent to data processing to join the waitlist',

  // Success state
  successTitle: "You're on the list!",
  successMessage: "We can't wait to make memories with you!",

  // Error messages
  emailRequired: 'Email address is required',
  emailInvalid: 'Please enter a valid email address',
  submitError: 'Uh oh! Something went wrong. Please try again.',
} as const;
